import * as React              from 'react';

import { Container,
         TypographyVariants,
         typography_variants } from 'src/components/common/typography/ui';

import { ColorVariant,
         themeColors         } from 'src/providers/theme/shared';



type Props = {
  variant: TypographyVariants;
  color?: ColorVariant | null;
  children: React.ReactNode;
}
export const Typography: React.FC<Props> = ({
  variant,
  color = null,
  children,
}) => {
  const lookAndFeel = { ...typography_variants.get(variant)! };
  if (color) {
    lookAndFeel.color = themeColors[color];
  }

  return (
    <Container lookAndFeel = { lookAndFeel }>
      { children }
    </Container>
  );
};
